import { IconProps } from ".";
import Icon from "./assets/scientific_work_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon44ScientificWork(props: IconProps) {
  return <BaseIcon className="text-6xl" icon={<Icon />} {...props} />;
}
